import PageHero from '../components/PageHero'
import { ABOUT_CONTENT } from '../content/aboutContent'

export default function AboutPage() {
  const { tagline, intro, mission, whatWeDo, whyChoose, commitment, heroImage } = ABOUT_CONTENT

  return (
    <div className="page">
      <PageHero
        title={tagline}
        lead={intro[0]}
        image={heroImage}
        imageAlt="Aegis team at a commercial facility"
        imagePosition="center 20%"
      />

      <section className="page-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 page-prose">
          {intro.slice(1).map((paragraph) => (
            <p key={paragraph.slice(0, 24)}>{paragraph}</p>
          ))}
        </div>
      </section>

      <section className="page-section page-section--alt">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <h2 className="page-section__title">{mission.title}</h2>
          <p className="page-section__lead">{mission.text}</p>
        </div>
      </section>

      <section className="page-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <h2 className="page-section__title">{whatWeDo.title}</h2>
          <p className="page-section__lead">{whatWeDo.intro}</p>
          <ul className="page-list page-list--columns">
            {whatWeDo.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <p className="page-section__outro">{whatWeDo.outro}</p>
        </div>
      </section>

      <section className="page-section page-section--alt">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <h2 className="page-section__title">{whyChoose.title}</h2>
          <div className="page-grid page-grid--2">
            {whyChoose.items.map((item) => (
              <div key={item.title} className="page-card page-card--flat">
                <h3 className="page-card__title">{item.title}</h3>
                <p className="page-card__text">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="page-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <h2 className="page-section__title">{commitment.title}</h2>
          <p className="page-section__lead">{commitment.text}</p>
        </div>
      </section>
    </div>
  )
}
